import { gql } from 'react-apollo';

export default gql`
  mutation offerReadyToInvest($offerId: ID!) {
    offerReadyToInvest(offerId: $offerId)
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/offerReadyToInvest.js